<template>
  <a @click="() => { click(link()) }" :class="{ 'router-link-active router-link-exact-active': menu.submenu }" class="menu-link">
    <i v-if="menu.icon" class="menu-icon" :class="menu.icon"></i>
    <i v-if="!menu.icon && !menu.root" class="menu-link-bullet" :class="bullet()">
      <span></span>
    </i>
    <span class="menu-text">
      {{
      menu.translate ? $t(menu.translate) : menu.title
      }}
    </span>
    <i v-if="menu.submenu" class="menu-arrow"></i>
  </a>
</template>

<script>
export default {
  name: "KTMenuItemText",
  components: {},
  props: {
    menu: Object,
    parentMenu: Object
  },
  methods: {
    /**
     * Get bullet class from config
     * @returns {string} class name
     */
    bullet: function() {
      // get the default bullet
      if (!this.menu.bullet) {
        this.menu.bullet = "dot";
      }
      // bullet class name
      return `menu-link-bullet-${this.menu.bullet}`;
    },
    /**
     * Get current menu link path
     * @returns {{}|{path: string}}
     */
    link: function() {
      // check if no link in this menu item
      if (!this.menu.page) {
        return {};
      }
      // pass the link prepend with slash
      return { path: `/${this.menu.page}` };
    },
    click(route) {
      this.$emit('click')
      this.$router.push(route)
    }
  }
};
</script>
